// Deterministic waveform helpers. Kept module-level so they never break hook deps.

export function seededBars(seed, count = 90) {
  let x = 0;
  for (let i = 0; i < seed.length; i++) x = (x * 31 + seed.charCodeAt(i)) >>> 0;
  return new Array(count).fill(0).map(() => {
    x = (x * 1103515245 + 12345) & 0x7fffffff;
    return 4 + ((x >> 8) % 22);
  });
}

// Deterministic progress ratio per id (avoids Math.random in render).
export function postProgress(id) {
  let x = 0;
  for (let i = 0; i < id.length; i++) x = (x * 131 + id.charCodeAt(i)) >>> 0;
  return 0.25 + ((x % 100) / 100) * 0.5;
}
